import { useCallback } from 'react'
import { graphql, useMutation } from 'react-relay'

import {
  useDislikeMutation$data,
  type useDislikeMutation as UseDislikeMutation
} from '@/__generated__/useDislikeMutation.graphql'

type CommitAsyncFn = (toUserId: string) => Promise<useDislikeMutation$data>

export const useDislikeMutation = (): [CommitAsyncFn, boolean] => {
  const [commit, isPending] = useMutation<UseDislikeMutation>(graphql`
    mutation useDislikeMutation($input: UpsertDislikeInput!) {
      upsertDislike(input: $input) {
        clientMutationId
        query {
          currentUser {
            ...LikesList_user @arguments(after: null)
          }
        }
      }
    }
  `)

  const commitAsync = useCallback<CommitAsyncFn>(
    (toUserId: string) =>
      new Promise((resolve, reject) =>
        commit({
          onCompleted: (response, errors) => {
            if (errors) {
              reject(errors)
            } else {
              resolve(response)
            }
          },
          variables: {
            input: {
              toUserId
            }
          }
        })
      ),
    [commit]
  )

  return [commitAsync, isPending]
}
